import React, { useState } from 'react';
import logger from '../../utils/logger';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Home, ShoppingCart, Package, User, LogOut, LogIn } from 'lucide-react';
import logo from '../../assets/logo.png';
import './Navbar.css';

function Navbar({
  showAuthButton = false,
  showCartButton = false,
  showBackButton = false,
  showLogoutButton = false,
  onBack,
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated, signOut } = useAuth();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = async () => {
    try {
      logger.debug('Logout button clicked, starting logout process...');
      const result = await signOut();
      logger.debug('Logout result:', result);
      if (result.success) {
        logger.debug('Logout successful, navigating to home...');
        navigate('/');
      } else {
        logger.error('Logout failed:', result.error);
      }
    } catch (error) {
      logger.error('Logout error:', error);
    }
  };

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate('/home');
    }
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div
          className="nav-brand"
          onClick={() => navigate(isAuthenticated ? '/home' : '/')}
          style={{ cursor: 'pointer' }}
        >
          <img src={logo} alt="tiniego" className="nav-logo" />
        </div>
        <div className="nav-actions">
          {showCartButton && (
            <button
              className="cart-btn"
              onClick={() => navigate('/cart')}
              title="View Shopping Cart"
            >
              🛒 Cart
            </button>
          )}
          {showBackButton && (
            <button className="back-btn" onClick={handleBack}>
              ← Back to Home
            </button>
          )}
          {showLogoutButton && isAuthenticated && (
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          )}
          {showAuthButton && !isAuthenticated && (
            <button className="nav-button" onClick={() => navigate('/auth')}>
              Log in / Sign up
            </button>
          )}
          {isAuthenticated && (
            <div className={`hamburger-menu ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
              <div className="hamburger-line"></div>
              <div className="hamburger-line"></div>
            </div>
          )}
        </div>
      </div>

      <div className={`dropdown-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="dropdown-container">
          <ul className="panel-menu" onClick={closeMenu}>
            {isAuthenticated ? (
              <>
                <li>
                  <button
                    type="button"
                    onClick={() => navigate('/home')}
                    className="menu-item-button"
                  >
                    <Home size={28} />
                    <span>Studio</span>
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={() => navigate('/cart')}
                    className="menu-item-button"
                  >
                    <ShoppingCart size={28} />
                    <span>Cart</span>
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={() => navigate('/orders')}
                    className="menu-item-button"
                  >
                    <Package size={28} />
                    <span>Orders</span>
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={() => navigate('/profile')}
                    className="menu-item-button"
                  >
                    <User size={28} />
                    <span>Profile</span>
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={handleLogout}
                    className="menu-item-button"
                  >
                    <LogOut size={28} />
                    <span>Logout</span>
                  </button>
                </li>
              </>
            ) : (
              <li>
                <button
                  type="button"
                  onClick={() => navigate('/auth')}
                  className="menu-item-button"
                >
                  <LogIn size={28} />
                  <span>Log In / Sign Up</span>
                </button>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
